import type CurrentAuthService from '../services/current-auth.service';
import type {IAttributes, IAugmentedJQuery, ILogService, IScope} from 'angular';

/**
 * @ngdoc directive
 * @name kpInjectToScope
 * @module portaro.directives
 *
 * @param {string} service Service name.
 *
 * @description
 * Requires admin privileges.
 *
 * Add service instance described by `service` name into $scope.
 *
 * Potentially unsafe, avoid use on production environment.
 */
export default class KpInjectToScopeDirective {
    public static readonly directiveName = 'kpInjectToScope';

    public transclude = true;

    public template = '<ng-transclude></ng-transclude>';

    public restrict = 'E';

    /*@ngInject*/
    constructor(
        private currentAuthService: CurrentAuthService,
        private $injector: angular.auto.IInjectorService,
        private $log: ILogService) {
    }

    public link($scope: IScope, $element: IAugmentedJQuery, $attrs: IAttributes) {
        this.$log.warn('Using kpInjectToScope directive...');

        if (!this.currentAuthService.hasRole('ROLE_ADMIN')) {
            return;
        }

        const serviceName = $attrs.service;

        $scope[serviceName] = this.$injector.get(serviceName);
    }
}